module.exports = __webpack_public_path__ + "static/img/image042.1d204db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image042.png
// module id = 2TkJ
// module chunks = 1